import * as Sentry from "@sentry/nuxt";

Sentry.init({
   // If set up, you can use your runtime config here
   // dsn: useRuntimeConfig().public.sentry.dsn,
   dsn: "https://5f69e0600704b6f34b3e1be91bc383bb@o469966.ingest.us.sentry.io/4508779080843264",

   // We recommend adjusting this value in production, or using tracesSampler
   // for finer control
   tracesSampleRate: 1.0,
   release: useRuntimeConfig().public.buildVersion || "dev",
   environment: process.env.NODE_ENV || "development",
   enabled: !import.meta.dev,

   // This sets the sample rate to be 10%. You may want this to be 100% while
   // in development and sample at a lower rate in production
   replaysSessionSampleRate: 0.1,

   // If the entire session is not sampled, use the below sample rate to sample
   // sessions when an error occurs.
   replaysOnErrorSampleRate: 1.0,

   // If you don't want to use Session Replay, just remove the line below:
   integrations: [Sentry.replayIntegration()],

   // Stale route chunks after a deploy; Nuxt reloads the page on its own.
   ignoreErrors: [
      /Importing a module script failed/,
      /Failed to fetch dynamically imported module/,
   ],

   // Setting this option to true will print useful information to the console while you're setting up Sentry.
   debug: false,
});
